import {DataTable} from '@management-ui/core';
import {reverse} from 'named-urls';
import * as React from 'react';
import {useCallback, useContext, useMemo} from 'react';
import {useHistory} from 'react-router-dom';
import {ServiceContext} from '../../../../components/Services';
import routes from '../../../../routes';

const Table = ({archive = false}) => {
  const services = useContext(ServiceContext);
  const history = useHistory();

  const goToDetail = useCallback((material) => {
    history.push(reverse(material.archived ? routes.archive.material.detail : routes.materials.detail, {id: material.id}));
  }, [history]);

  return (
    <DataTable
      title=""
      columns={useMemo(() => [
        {title: 'Name', field: 'name'}
      ], [])}
      loadData={useCallback(query => new Promise((resolve, reject) => {
        const params = {};
        if (archive) {
          params.archive = 'only';
        }
        services.material.getTableMaterials(query, params)
          .then(response => {
            resolve({
              data: response.data, page: response.meta.current_page - 1, totalCount: response.meta.total
            });
          }).catch(() => reject());
      }), [services, archive])}
      onRowClick={goToDetail}
    />
  );
};

export default Table;
